import { render, staticRenderFns } from "./People.vue?vue&type=template&id=9ba8fbae&scoped=true"
import script from "./People.vue?vue&type=script&lang=ts"
export * from "./People.vue?vue&type=script&lang=ts"
import style0 from "./People.vue?vue&type=style&index=0&id=9ba8fbae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba8fbae",
  null
  
)

export default component.exports